import { gql } from "@apollo/client";

export const SITE_FRAGMENT = gql`
  fragment SitePart on Site {
    id
    name
    url
    categoryId
    category {
      id
      name
    }
    productsCount
  }
`;

export const SITES = gql`
  query SitesQuery($where: SitesFiltersInput!) {
    sites(where: $where) {
      hasMore
      total
      results {
        ...SitePart
      }
    }
  }
  ${SITE_FRAGMENT}
`;

export const SITE = gql`
  query SiteQuery($id: Int!) {
    site(id: $id) {
      ok
      error
      result {
        ...SitePart
      }
    }
  }
  ${SITE_FRAGMENT}
`;

export const UPDATE_SITE = gql`
  mutation UpdateSiteMutation($id: Int!, $input: UpdateSiteInput!) {
    updateSite(id: $id, input: $input) {
      ok
      error
    }
  }
`;

export const SITE_MARKET_VALUE = gql`
  query SiteMarketValue($id: Int!) {
    siteMarketValue(id: $id) {
      ok
      error
      marketValue
      totalProducts
      totalQuantity
    }
  }
`;
